import { AppRootState } from '../../../../../store/models/app-state.model';

export const getFirmwareFileIdSelector = (state: AppRootState): number | null =>
  state.firmware.firmwareFileId;
